import React, { useRef } from "react";
import { Wrapper } from "./styles";
import {
  AtRiskComponent,
  BannerComponent,
  IntroComponent,
  FlipCards,
  Quote,
  Replay,
  Title,
  UserAnswer,
  TextAndImage,
  TextAndFlipCard,
  TitleLink,
} from "./components";
import Summary from "./summary/summary";
import { Answer, DebriefComponent } from "../../types";
import { useApp } from "../../state/app";
import { MODE } from "../../config/consts";
import scorm from "../../services/scorm";

const MAP = {
  richText: IntroComponent,
  titledImage: BannerComponent,
  quote: AtRiskComponent,
  quoteWithString: Quote,
  title: Title,
  userAnswer: UserAnswer,
  replay: Replay,
  summary: Summary,
  textAndImage: TextAndImage,
  textAndFlipCard: TextAndFlipCard,
  titleLink: TitleLink,
  flipCards: FlipCards,
};

type DebriefProps = {
  sections: { components: DebriefComponent[] }[];
  sceneId: string;
  answers: Answer[];
  backgroundColor?: string;
  lastScene?: boolean;
};

export default function Debrief({
  sections,
  sceneId,
  backgroundColor,
  lastScene = false,
}: DebriefProps) {
  const wrapper = useRef<any>(null);

  React.useEffect(() => {
    if (lastScene) {
      window.parent.postMessage({ type: "course_completed" }, "*");
    }
    if (!MODE.startsWith("scorm")) return;
    if (!scorm.isConnected()) return;
    if (lastScene) {
      scorm.complete();
    }
  }, [lastScene]);

  React.useEffect(() => {
    document.title = "Debrief";
  }, []);

  React.useEffect(() => {
    useApp.getState().setDebriefMode(null);
  }, []);

  React.useEffect(() => {
    wrapper.current?.focus();
  }, []);

  return (
    <Wrapper ref={wrapper} style={{ backgroundColor }}>
      {sections?.map((items, pageIndex) => {
        return (
          <div key={`parent_${pageIndex}`} className={`section`}>
            {items.components.map(({ id, ...props }, index) => {
              if (!id) return <React.Fragment key={index}></React.Fragment>;
              // @ts-ignore
              const Component = MAP[id];
              return (
                <Component
                  key={`${id}${id}-${index}`}
                  // @ts-ignore
                  {...props[id]}
                  debriefSceneId={sceneId}
                />
              );
            })}
          </div>
        );
      })}
    </Wrapper>
  );
}
